/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CompanyFilterViewModel } from "../types/CompanyFilterViewModel.ts";

export const companyFilterViewModelSchema = z.object({
  search: z.string().nullish(),
  companyId: z.number().int().nullish(),
  pageNumber: z.optional(z.number().int().default(1)),
  pageSize: z.optional(z.number().int().default(20)),
}) as unknown as ToZod<CompanyFilterViewModel>;
